export { AboutMoreSchema, CardInfoSchema } from "./schemas";
export type { CardInfoType } from "./types";
